import { render, staticRenderFns } from "./SingUpView.vue?vue&type=template&id=0ef80440&"
import script from "./SingUpView.vue?vue&type=script&lang=js&"
export * from "./SingUpView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports